import type { NewsItem } from '@/types';

export const newsList: NewsItem[] = [
  {
    id: 'xinghe-changge-update-24',
    title: '《星河长歌》更新至24集，星陨大典名场面引爆热议',
    subtitle: '姜挽与萧临的宿命对决成为本季讨论度最高剧情',
    category: 'news',
    publishedAt: '2025-10-11 22:10',
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20chinese%20palace%20under%20starry%20night%20with%20golden%20lanterns%20and%20indigo%20sky%2C%20cinematic%20historical%20drama%20scene%2C%20warm%20amber%20highlights&width=1200&height=675&seq=hn-news-xinghe&orientation=landscape',
    content: [
      '备受关注的大型古装奇幻剧《星河长歌》于本周更新至第 24 集，剧中"星陨大典"一段以极高规格的视效与饱满的情感张力，成为全平台讨论度最高的剧情之一。',
      '据剧方介绍，为了让星象与战斗场面的呈现更具说服力，制作团队耗时数月搭建了可实时驱动的星辰系统，并邀请多位天文学顾问参与设计，力求在浪漫想象与真实细节之间找到平衡。',
      '随着剧情进入中段，姜挽与萧临之间"注定分离又彼此奔赴"的关系逐渐走向高潮。不少观众表示，这部剧最动人的并非炫目的特效，而是乱世之中两个人始终没有放开的双手。',
      '该剧目前每周更新六集，预计将在本季度内迎来收官。',
    ],
  },
  {
    id: 'anyong-zhicheng-rating',
    title: '《暗涌之城》口碑持续走高，评分稳定在9.1',
    subtitle: '真实案件肌理与人物命运交织，被誉为年度悬疑黑马',
    category: 'news',
    publishedAt: '2025-10-10 20:35',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20coastal%20city%20skyline%20at%20dusk%20with%20fog%20and%20amber%20window%20lights%2C%20dark%20navy%20thriller%20cinematic%20atmosphere&width=1200&height=675&seq=hn-news-anyong&orientation=landscape',
    content: [
      '悬疑剧《暗涌之城》播出过半，评分稳定在 9.1，成为本季度最受好评的国产剧集之一。观众普遍认为，剧集最难得的地方在于没有把悬疑当作噱头，而是让人物的选择推动案情。',
      '编剧秦朗在采访中透露，故事灵感来自对多起真实社会新闻的观察，"我们想写的不是谁是凶手，而是为什么会发生"。这种写法让每一个角色都带有复杂性，也让真相显得格外沉重。',
      '随着主角沈黎逐渐接近家族秘密，剧情的紧张感还在持续升级。平台数据显示，该剧的追更留存率长期位居同期前列。',
    ],
  },
  {
    id: 'changye-jiangming-trailer',
    title: '《长夜将明》发布定档预告，多线叙事悬念拉满',
    subtitle: '二十年前旧案与当下追凶双线并行，看点密集',
    category: 'trailer',
    publishedAt: '2025-10-08 21:40',
    cover:
      'https://readdy.ai/api/search-image?query=Wide%20cinematic%20rainy%20night%20city%20with%20amber%20neon%20reflections%2C%20lone%20detective%20under%20streetlight%2C%20deep%20navy%20suspense%20film%20still&width=1200&height=675&seq=hn-news-changye&orientation=landscape',
    content: [
      '电影《长夜将明》正式发布定档预告，短短两分钟的片花以冷峻的色调和克制的手持摄影，勾勒出一起跨越二十年悬案的轮廓。',
      '预告中，刑警队长沈默（张砚清 饰）与师父之间的对话反复出现，暗示着案件背后更深的情感张力。导演陈砚舟表示，影片想探讨的是"当正义与亲情冲突时，人还能否守住底线"。',
      '该片已定档本月底上映，同期将开启多城点映。',
    ],
  },
  {
    id: 'shanhai-gui-xu-feature',
    title: '专题：从《山海纪·归墟》看国产奇幻视效的进阶',
    subtitle: '神兽、迷阵与山海世界观背后，是工业化的稳步积累',
    category: 'feature',
    publishedAt: '2025-10-06 16:20',
    cover:
      'https://readdy.ai/api/search-image?query=Fantasy%20floating%20mountain%20islands%20above%20sea%20of%20clouds%20at%20sunrise%2C%20golden%20light%20and%20mist%2C%20epic%20oriental%20landscape&width=1200&height=675&seq=hn-news-shanhai&orientation=landscape',
    content: [
      '《山海纪·归墟》上映后，关于"国产奇幻能不能拍好"的讨论再次热了起来。抛开剧情争议，影片在视效工业化上的稳步积累，值得单独聊一聊。',
      '影片中的神兽并非单纯堆砌细节，而是先确立了生物的运动逻辑与材质语言，再交由特效团队逐层实现。这种"先设计后制作"的流程，让画面在大银幕上更经得起推敲。',
      '更重要的是，山海世界观提供了一套天然的叙事容器：每一座山、每一片海都可以承载一段传说。只要创作者愿意在人物身上多花心思，这套体系就还有很大的想象空间。',
    ],
  },
  {
    id: 'wutai-zhiwang-finale',
    title: '《舞台之王》半决赛落幕，四强席位正式产生',
    subtitle: '跨界改编赛制让歌手集体"打破舒适圈"',
    category: 'news',
    publishedAt: '2025-10-05 22:00',
    cover:
      'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20golden%20spotlight%20beams%20and%20audience%20silhouette%2C%20deep%20navy%20and%20amber%20palette%2C%20live%20music%20cinematic%20scene&width=1200&height=675&seq=hn-news-wutai&orientation=landscape',
    content: [
      '音乐竞演综艺《舞台之王》半决赛结束，四位歌手凭借各具风格的舞台表现拿到决赛门票。本季"跨界改编"的赛制要求选手挑战从未涉猎的曲风，成为节目最大看点。',
      '有观众评价，正是这种"被迫跳出舒适圈"的设定，让歌手的真实水准与音乐理解力得以充分展现。多位选手在舞台上完成了个人的高光时刻。',
      '决赛将于下月直播，节目组表示将启用更立体的舞台结构与实时乐队伴奏。',
    ],
  },
  {
    id: 'shaonian-trailer',
    title: '《少年歌行天下》曝最新预告，江湖群像初现端倪',
    subtitle: '断剑少年踏遍九州，热血成长引期待',
    category: 'trailer',
    publishedAt: '2025-10-04 19:30',
    cover:
      'https://readdy.ai/api/search-image?query=Ethereal%20bamboo%20forest%20at%20dawn%20with%20golden%20light%20rays%20and%20lone%20swordsman%2C%20misty%20green%20and%20amber%20wuxia%20scene&width=1200&height=675&seq=hn-news-shaonian&orientation=landscape',
    content: [
      '武侠剧《少年歌行天下》发布最新预告，随着镜头从古镇一路推向高山云海，一个层次丰富的江湖群像逐渐浮现。',
      '预告重点呈现了主角裴野的成长线：从带着断剑闯荡的无名少年，到逐渐懂得何为责任。制作方表示，剧集希望找回传统武侠里"义"与"江湖气"的质感。',
      '该剧目前正在持续更新中。',
    ],
  },
  {
    id: 'chengshi-weidao-feature',
    title: '专题：为什么美食纪录片总能治愈我们',
    subtitle: '《城市味道》用巷弄老味道串起人间烟火',
    category: 'feature',
    publishedAt: '2025-10-02 15:10',
    cover:
      'https://readdy.ai/api/search-image?query=Bustling%20old%20chinese%20night%20food%20street%20with%20warm%20lanterns%20and%20steaming%20stalls%2C%20amber%20and%20coral%20glow%2C%20cozy%20documentary%20scene&width=1200&height=675&seq=hn-news-chengshi&orientation=landscape',
    content: [
      '《城市味道》没有宏大叙事，只是安静地走进一座座城市的清晨与深夜，记录那些开了几十年的小店和守着它们的人。',
      '美食纪录片的治愈力，或许正来自这种"具体"：一碗热气腾腾的面、一句熟客的招呼、老板手上那张有些油渍的菜单。它提醒我们，生活的踏实感往往藏在最日常的细节里。',
      '如果你最近感到疲惫，不妨打开一集，让烟火气慢慢把心填满。',
    ],
  },
  {
    id: 'wusheng-zhijing-feature',
    title: '《无声之境》幕后：在沉默里如何讲好一个故事',
    subtitle: '声音设计成为叙事主角，细节见功力',
    category: 'feature',
    publishedAt: '2025-09-30 14:00',
    cover:
      'https://readdy.ai/api/search-image?query=Sunlit%20southern%20town%20alleyway%20in%20summer%20with%20brick%20walls%20and%20hanging%20plants%2C%20warm%20amber%20light%2C%20gentle%20nostalgic%20film%20still&width=1200&height=675&seq=hn-news-wusheng&orientation=landscape',
    content: [
      '《无声之境》把主角设定为一位失聪的调音师，这意味着一部关于"声音"的电影，却要用沉默来讲述。创作团队的解法，是让振动、光线和细节动作成为另一种语言。',
      '片中大量使用了近距离的环境音与身体接触音，让观众跟随主角"感受"声音，而不是"听见"声音。这种处理方式让不少观众在结尾处湿了眼眶。',
      '好的作品从不依赖台词堆砌情感，它只是安静地把人放回到生活的现场。',
    ],
  },
];

export const newsCategoryLabels: Record<string, string> = {
  news: '新闻',
  trailer: '预告',
  feature: '专题',
};